
import './App.css';
import React, { useState }  from 'react';
import Api                  from "./includes/Api";
import IngredientsList      from "./components/IngredientsList"
import IngredientResults    from "./components/IngredientResults"
import IngredientDetails    from "./components/IngredientDetails"
import Corrections          from "./components/Corrections"


export default (props) => {
    
    const [ingredients,         setIngredients]         = useState([]); // ingredients from text area
    const [searched_ingredients, setSearchedIngredients] = useState([]);
    const [search_results,      setSearchResults]       = useState([]); // array or results
    const [opened_result,       setOpenedResult]        = useState(null); // the opened result (the user is choosing a proposal)
    const [selected_proposals,  setSelectedProposals]   = useState([]); // the selected proposals
    const [list,                setList]                = useState([]); // the final list of the valid ingredients
    const [details,             setDetails]             = useState(null);
    const [opened_corrections,  setOpenedCorrections]    = useState(null);
    const [corrections,         showCorrections]         = useState(null);
    
    const resetState = (reset_ingredients) => {
        
        setSearchResults([]);
        setOpenedResult(null);
        setSelectedProposals([]);
        setList([]);  
        setDetails(null);
        setOpenedCorrections();
        showCorrections(null);
        //setIngredients([]);       
    };
    
    const onChangeIngredientsList = async (e) => {

        const list          = e.target.value.split("\n");
        const ingredients   = list.map( ingredient => ingredient );
        
        setIngredients(ingredients);
    };

    const search = async () => {
        
        resetState();         
         
        const search = await Api.post("search", {ingredients:ingredients});
        
       // search.data.content.searched = ingredients;
       const deep_copy_ingredients = [...ingredients];
       
        setSelectedProposals([]);
        setSearchedIngredients(deep_copy_ingredients);
   
        await setSearchResults(search.data.content);       
        
        console.log(ingredients);
    };
    
    const reset = () => {
        
        resetState();
    };
    

    const showDetails = async (index) => {
        
        const ingredient_id = search_results[index]?.id;
 
        if(details && details.ingredient_index === index){
            
            setDetails(null);
        }
        else{
            if(ingredient_id){

                const details = await Api.get(ingredient_id+"/details");

                if(details.data.error === false){

                    setDetails({ingredient_index:index, data:details.data.content});
                } 
            }
        }
    };
    
    
    const correct = async (ingredient_index) => {
        
        const erroneous_entry = ingredients[ingredient_index];
        
        const search = await Api.get("correct", {search:erroneous_entry});
        
        if( search.data.error === false ){
            
            setOpenedCorrections(ingredient_index);
            showCorrections(search.data.content);
        }
    };
    
    
    const selectCorrection = async (ingredient_index, correction) => {
        
        
        const search = await Api.post("search", {ingredients:[correction.ingredient]});
        
        if(search.data.error === false){
            
            const result = search.data.content[0];

            // Save the corrected result into the global results
            search_results[ingredient_index] = result;
            
            // Save the selected correction into the fina list
            //list[ingredient_index] = result;
            
            // Update the ingredient title with the selected correction ningredient name
           // ingredients[ingredient_index]           = correction.ingredient;
            searched_ingredients[ingredient_index]  = correction.ingredient;                        
            
            setOpenedCorrections(null);
            showCorrections(null);
            
            //setList([...list]);
            //setIngredients([...ingredients]);                    
        }
     
    };
    
    return (

        <div>
           

            <IngredientsList
                onChange={onChangeIngredientsList}/>
                
            <p id="container-submit-btn">
                <button onClick={search}>Envoyer</button>       
            </p>
            
            <main>                   
                {                     
                    search_results.map( (ingredient_proposals, index) => {
                                
                        return  <div>
                           
                                    <IngredientResults 
                                        ingredient              = {ingredient_proposals?.common_ingredient_name ?? searched_ingredients[index]}                                     
                                        ingredient_index        = {index}
                                        entries                 = {ingredient_proposals}
                                        corrections             = {opened_corrections === index ? corrections : null}
                                        is_opened               = {opened_result === index}                                        
                                        onSelectCorrection      = {selectCorrection}
                                        onOpen                  = {() => setOpenedResult(index)}
                                        onClose                 = {() => setOpenedResult(null)}
                                        onCorrect               = {correct}
                                        onShowDetails           = {showDetails}
                                    /> 
                                    
                                    {
                                        details && details.ingredient_index === index ? 
                                        <IngredientDetails details={details} />
                                        : ""
                                    }
                                                                       
                                </div>
                                
                    })
                }
            </main>
        </div>
    );
}

